import React from 'react';

/** Row above a table: left = search / view switch, right = primary actions. */
export default function Toolbar({ left, right, className = '' }) {
    return (
        <div className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4 ${className}`}>
            <div className="flex flex-wrap items-center gap-2 min-w-0">{left}</div>
            <div className="flex flex-wrap items-center gap-2 sm:justify-end">{right}</div>
        </div>
    );
}
